import { render } from "./StrategyList.vue?vue&type=template&id=6777c0eb&scoped=true&lang=true"
import script from "./StrategyList.vue?vue&type=script&lang=js"
export * from "./StrategyList.vue?vue&type=script&lang=js"

import "./StrategyList.vue?vue&type=style&index=0&id=6777c0eb&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-6777c0eb"

export default script